import { render } from "./Hue.vue?vue&type=template&id=d0fd3296"
import script from "./Hue.vue?vue&type=script&lang=js"
export * from "./Hue.vue?vue&type=script&lang=js"

import "./Hue.vue?vue&type=style&index=0&id=d0fd3296&lang=css"

import exportComponent from "/home/mathias/PhpstormProjects/clone/vue3-color/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__